import { Box } from '@mui/material';
import React from 'react';

import routes from '@/assets/constants/routes-no.ts';
import { Timer } from '@/ui/Timer.tsx';

import { UnderlinedText } from '../../../../../../components/UnderlinedText/index.ts';
import { ArrowLink } from '../../../../../_common/components/ArrowLink.tsx';
import { SUMMER_JUNE_2024_COMPETITION_END_DATE } from '../../../config.ts';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

const dateFormatter = new Intl.DateTimeFormat('no', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});
const dateStr = dateFormatter.format(SUMMER_JUNE_2024_COMPETITION_END_DATE);

export type TimerSectionJuneProps = {
  // Empty
};

export const TimerSectionJune: React.FC<TimerSectionJuneProps> = () => {
  return (
    <Section
      sx={{
        gap: '20px',
        flexDirection: { md: 'row' },
        flexWrap: { md: 'wrap', xl: 'initial' },
      }}
    >
      <Box
        sx={{
          textAlign: { xs: 'center', xl: 'left' },
          flex: { xl: 1 },
          width: { md: '100%', xl: 'auto' },
          mb: { md: 2 },
          pr: { xl: 8 },
        }}
      >
        <div className="mb-6 typography-v1-h1">Alle bør sjekke</div>

        <p className="mx-auto mb-2 max-w-[70ch] typography-v1-body2">
          Gjennom å sjekke gjelden sin senket Scoopr-brukerne rentekostnadene på sine forbrukslån og
          kredittkort med 250 millioner kroner i 2023!
        </p>
        <p className="mx-auto mb-2 max-w-[70ch] typography-v1-body2">
          <b>Vi vet at enda flere kan få lavere rente.</b> For å få enda flere til å sjekke følger
          vi opp med enda en trekning.
          <br />
          Denne gangen vil vi at alle skal se hvor mye de faktisk betaler i renter og avdrag de
          neste 12 mnd.
        </p>
        <p className="mx-auto mb-6 max-w-[70ch] typography-v1-body2">
          Kanskje du får en overraskelse?
        </p>

        <CTA />
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.default,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Premie</p>
        <p className="typography-v1-display">10 vinnere</p>
        <p className="-my-0.5 typography-v1-h2">får en pause fra gjelden</p>
        <p className="mb-8 typography-v1-display">
          i <UnderlinedText>et helt</UnderlinedText> år
        </p>

        <p className="mb-4 typography-v1-body3">
          Vi overtar regningene på kredittkort og forbrukslån i 12 mnd.
          <br />
          Maks. 80 000 kr per vinner.
        </p>

        <ArrowLink
          to={routes.SUMMER_JUNE_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.secondary.light,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Avsluttes</p>
        <p className="typography-v1-display">{dateStr}</p>
        <p className="mb-2 typography-v1-h2">om</p>
        <Timer date={SUMMER_JUNE_2024_COMPETITION_END_DATE} />

        <p className="mt-6 mb-4 typography-v1-body3 md:mt-8 xl:mt-12">
          Vinnerne kontaktes via e-post og mobil. Vi tar hensyn til personvern og publiserer ikke
          vinnere uten samtykke.
        </p>

        <ArrowLink
          to={routes.SUMMER_JUNE_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
    </Section>
  );
};
